// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3581":"f312d893","4718":"fff776fe","4779":"f312d893","6779":"f312d893"}[chunkId] + ".chunk.css";
};